import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BankApproveList: { loading: false, data: null, error: null },
  BankApproveUpdate: { loading: false, data: null, error: null },
};

export const BankApproveSlice = createSlice({
  name: "bankapprove",
  initialState,
  reducers: {
    fetchBankApproveListRequest: (state, action) => {
      state.BankApproveList.loading = true;
      state.BankApproveList.error = null;
    },
    fetchBankApproveListSuccess: (state, action) => {
      state.BankApproveList.data = action.payload;
      state.BankApproveList.loading = false;
      state.BankApproveList.error = null;
    },
    fetchBankApproveListFailure: (state, action) => {
      state.BankApproveList.data = null;
      state.BankApproveList.loading = false;
      state.BankApproveList.error = action.payload;
    },
    BankApproveUpdateRequest: (state, action) => {
      state.BankApproveUpdate.loading = true;
      state.BankApproveUpdate.error = null;
    },
    BankApproveUpdateSuccess : (state, action) => {
      state.BankApproveUpdate.data = action.payload;
      state.BankApproveUpdate.loading = false;
      state.BankApproveUpdate.error = null;
      state.BankApproveList = updateBankDetailsSuccess(action.payload, {
        ...state.BankApproveList,
      });
    },
    BankApproveUpdateFaliure : (state, action) => {
      state.BankApproveUpdate.data = null;
      state.BankApproveUpdate.loading = false;
      state.BankApproveUpdate.error = action.payload;
    },
  },
});

function updateBankDetailsSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((target) => {
    if (target._id !== dataToUpdate._id) return target;
    return { ...target, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchBankApproveListRequest,
  fetchBankApproveListSuccess,
  fetchBankApproveListFailure,
  BankApproveUpdateRequest,
  BankApproveUpdateSuccess ,
  BankApproveUpdateFaliure ,
} = BankApproveSlice.actions;

export const getBankApproveSliceListState = (state) =>
  state.bankapprove?.BankApproveList;
export const getBankApproveSliceUpdateState = (state) =>
  state.bankapprove?.BankApproveUpdate;

export default BankApproveSlice.reducer;
